import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import AppLoading from './ui/AppLoading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ZoomImage',
  props: {
    src: {
      type: String,
      required: true
    }
},
  setup(__props) {



const isZoomed = ref(false)

return { __sfc: true,isZoomed }
}

})